import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Widget, ColumnProps, Button } from '@digital/ui';
import { Table, Tooltip } from 'antd'
import { getHistoricoOrdemCompra } from '@app/api/sas/ordemCompra';
import { Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import ModalHistoricoArquivo from '../WidgetDocumentacao/ModalHistoricoArquivo';
import ModalComentarios from './Comentarios/ModalComentarios';
import { useRecoilState } from 'recoil';
import { reloadState } from '../atoms';


const columns: ColumnProps<any>[] = [
  // {
  //   dataIndex: 'id',
  //   width: '1%'
  //   render: () => ''
  // },
  {
    title: 'Usuário Responsavel',
    dataIndex: 'usuarioResponsavel',
    key: 'usuarioResponsavel',
    width: '15%',
  },
  {
    title: 'Descrição',
    dataIndex: 'descricao',
    key: 'descricao',
    width: '35%',
    render: (text, record, index) => {
      if (record.descricao == undefined) return undefined
      const descricao = record.descricao.split('\n')
      if (descricao.lenght === 1) return record.descricao
      return (
        <>
          {descricao.map((c: string, index: number) => {
            if (index < (descricao.length - 1)) {
              return <>
                {c} <br></br>
              </>
            } else {
              return <>
                {c}
              </>
            }
          })}
        </>
      )
    },
  },
  {
    title: 'Data / Hora',
    dataIndex: 'dataHoraFormatada',
    key: 'dataHoraFormatada',
    width: '10%',
  },
  {
    title: 'Status Anterior',
    dataIndex: 'statusAnterior',
    key: 'statusAnterior',
    width: '20%',
  },
  {
    title: 'Novo Status',
    dataIndex: 'statusNovo',
    key: 'statusNovo',
    width: '20%',
    className: 'td-inicio'
  }, {
    title: 'Ações',
    dataIndex: '',
    width: '5%',
    render(text, record, index) {
      return (
        <>
          <Visibility
            visible={isObjNotEmpty(record.sasDocumentoOrdemCompraId, true)}
          >
            <ModalHistoricoArquivo sasDocumentoOrdemComraId={record.sasDocumentoOrdemCompraId} />
          </Visibility>
          <Visibility visible={record.mensagens.length > 0} >
            <ModalComentarios mensagens={record.mensagens} />
          </Visibility>
        </>
      )
    }
  }
];

interface HistoricoProps {
  ordemCompraId: string;
}

const AbaHistoricoOrdemCompra = ({ ordemCompraId }: HistoricoProps) => {
  const [historico, setHistorico] = useState<any[]>([]);
  const [url, setURL] = useState(window.location.href);
  const [reload, setReload] = useRecoilState(reloadState);

  if (window.location.href != url) {
    setURL(window.location.href);
    if (window.location.href.toLocaleLowerCase().includes("historico")) {
      setReload(!reload);
    };
  }
  
  useEffect(() => {
    if (ordemCompraId) {
      setHistorico([])
      getHistoricoOrdemCompra(ordemCompraId).then(retorno => {
        if (retorno) setHistorico(retorno);
      });
    }
  }, [reload]);

  return (
    <Widget>
      <PerfectScrollbar>
        <Visibility>
          <Table
            indentSize={36}
            columns={columns}
            rowKey="index"
            dataSource={historico}
            pagination={false}
            expandIcon={props => {
              const expanded = !props.record.children.length
                ? 'ant-table-row-spaced'
                : props.expanded
                  ? 'ant-table-row-expanded'
                  : 'ant-table-row-collapsed';
              return (
                <div
                  className={`ant-table-row-expand-icon ${expanded}`}
                  onClick={e => props.onExpand(props.record, e)}
                />
              );
            }}
          // expandedRowRender={record => <div>{record.comentario}</div>}
          />
        </Visibility>
      </PerfectScrollbar>
    </Widget>
  );
};

export default AbaHistoricoOrdemCompra;
